import React from 'react';
import Router from './components/router/Router';

import { ToastProvider } from '@heroui/react';

const App = () => {
  return (
    <>
      <ToastProvider placement="top-right" toastOffset={40} />
      <Router />
    </>
  );
};

export default App;
